import React from "react";
import _ from "lodash";
import cx from "classnames";
import s from "./tabs.scss";
import BetaLabel from "Components/betaLabel/BetaLabel";

export default class Tabs extends React.Component {
  constructor(props) {
    super(props);

    const tabNames = Object.keys(props.tabs);
    let firstTab = tabNames[0];
    let currentTab = null;

    let urlTab = null;
    if (!IS_APP) {
      // it removes the hash in front of the string
      urlTab = decodeURI(this.props.location.hash.substring(1));
    }
    // if the hash part of the url does not correspond
    // to one of the tabs, show the first one
    if (!tabNames.includes(urlTab)) {
      currentTab = firstTab;
    } else {
      currentTab = urlTab;
    }

    this.state = {
      currentTab,
    };
  }

  getComponentToShow() {
    return this.props.tabs[this.state.currentTab];
  }

  showTab(name) {
    this.setState({ currentTab: name });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextTabNames = Object.keys(nextProps.tabs);

    // when user change language of the app in the settings
    // we must reset the current tab to the new, translated name
    if (nextTabNames.indexOf(this.state.currentTab) === -1) {
      this.setState({ currentTab: nextTabNames[0] });
    }
  }

  changeTab(name, e) {
    // const tab = e.currentTarget.parentElement
    // this.setState({tab.getBoundingClientRect()})
    if (!IS_APP) {
      document.location.hash = encodeURI(name);
    }
    this.showTab(name);
  }

  render() {
    const { className, tabs, newTagOnIndex } = this.props;
    const { currentTab } = this.state;

    const tabNames = Object.keys(tabs);
    let toShow = this.getComponentToShow(currentTab);

    let idx = -1;
    let tabsToRender = _.map(tabNames, (name) => {
      idx++;
      let isActive = name === currentTab;

      if (!tabs[name]) return "";
      return (
        <div className={cx(s.item, { [s.active]: isActive })} key={name} onClick={(e) => this.changeTab(name, e)}>
          {name}

          {newTagOnIndex && idx === newTagOnIndex && <BetaLabel fullyRounded />}
        </div>
      );
    });

    return (
      <div className={cx(className, s.tabBar)}>
        <div className={s.wrapScroll}>
          <div className={s.wrapItems}>{tabsToRender}</div>
        </div>
        <div className={s.content}>{toShow}</div>
      </div>
    );
  }
}
